/**
 * 套餐选择页浮层（T14）。
 *
 * 单独挂在设置页「滚动区之外」的页面根容器下：整页浮层因此不会被内容区滚动带走，
 * 始终盖住可见内容区。打开 / 关闭状态由设置页提升到根层管理。
 */
import { AnimatePresence } from 'framer-motion';
import type { ReactElement } from 'react';

import { PlanSelectionPage } from './PlanSelectionPage';

export interface SubscriptionPlanPageProps {
  /** 是否展开套餐选择页。 */
  open: boolean;
  /** 关闭（返回设置页）。 */
  onClose: () => void;
}

/** 套餐选择页的挂载壳：负责进出场动画与条件渲染。 */
export function SubscriptionPlanPage({ open, onClose }: SubscriptionPlanPageProps): ReactElement {
  return (
    <AnimatePresence initial={false}>
      {open ? <PlanSelectionPage onClose={onClose} /> : null}
    </AnimatePresence>
  );
}